import { api } from 'store/api/strapiService';

import { REWARD_SYSTEM_TYPES } from 'components/config/rewardSystem';

export const rewardSystemController = api.injectEndpoints({
  endpoints: (build) => ({
    getUserInfo: build.query({
      query: ({ email, type }) => ({
        url: '/api/rs-users',
        params: {
          'filters[email][$eq]': email,
          'filters[type][$eq]': type,
          'populate[companies][filters][isActive][$eq]': true,
        },
      }),
      providesTags: () => [{ type: 'RSUsers' }],
    }),
    acceptTerms: build.mutation({
      query: ({ userId }) => ({
        url: `/api/rs-users/${userId}`,
        method: 'PUT',
        body: {
          data: {
            termsAccepted: true,
          },
        },
      }),
      invalidatesTags: () => [{ type: 'RSUsers' }],
    }),
    getCompany: build.query({
      query: ({ id, type }) => ({
        url: `/api/rs-companies/${id}`,
        params: {
          'filters[type][$eq]': type,
          'populate[seasons][filters][isActive][$eq]': true,
          'populate[seasons][sort][0]': 'startDate:desc',
        },
      }),
    }),
    getSeasons: build.query({
      query: ({ companyId, type }) => ({
        url: '/api/rs-seasons',
        params: {
          'filters[company][documentId][$eq]': companyId,
          'filters[type][$eq]': type,
          sort: 'startDate:desc',
          populate: '*',
        },
      }),
    }),
    getSeason: build.query({
      query: ({ id, type }) => ({
        url: `/api/rs-seasons/${id}`,
        params: {
          'filters[type][$eq]': type,
          populate: '*',
        },
      }),
    }),
    getSettings: build.query({
      query: ({ type }) => ({
        url: `/api/${type === REWARD_SYSTEM_TYPES.media ? 'rs-media-setting' : 'rs-setting'}`,
      }),
    }),
  }),
});

export const {
  useGetUserInfoQuery,
  useAcceptTermsMutation,
  useGetCompanyQuery,
  useGetSeasonsQuery,
  useGetSeasonQuery,
  useGetSettingsQuery,
} = rewardSystemController;
